import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Select } from 'antd';

export interface IDeliveryMethodSelectProps extends RouteComponentProps<{ eshop: string }> {
  name: string;
  onChange: (e: any, method: GQL.IDeliveryMethod | undefined) => void;
  value: string | undefined;
  methods?: Array<GQL.IDeliveryMethod>;
  style?: any;
}

export class DeliveryMethodSelect extends React.PureComponent<IDeliveryMethodSelectProps> {

  constructor(props: IDeliveryMethodSelectProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { value, onChange, style, methods } = this.props;

    if (methods) {
      return (
        <Select
          placeholder={'Choose delivery method'}
          onChange={this.onChange}
          value={value}
          style={...style}
        >
          {methods.map(l => {
            return (
              <Select.Option key={l.id} value={l.id}>
                {l.title}
              </Select.Option>
            );
          })}
        </Select>
      );
    }

    return (
      <Select placeholder={'Choose delivery method'} style={...style} />
    );
  }

  private onChange(value: string) {
    const { methods } = this.props;

    const method = methods && methods.find((l: GQL.IDeliveryMethod) => l.id === value);

    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value,
        }
      }, method);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Others/DeliveryMethodSelect/DeliveryMethodSelect.tsx